import React, {useEffect} from 'react'
import apiClient from '../http-common';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { setPlans, setCategories } from './planSlice';

export const LoadPlans = () => {
  const dispatch = useDispatch();
    const { isLoading: isLoadingProducts, refetch: getProducts } = useQuery(
        "plans",
        async () => {
          return await apiClient.get("/api/investment-plans");
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res && res.data && res.data.status === 'success') {
                dispatch(setPlans(res.data.plans));
                dispatch(setCategories(res.data.categories));
                const event = new Event('updatedStorage');
                window.dispatchEvent(event);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      useEffect(() => {
        getProducts();
      }, []);
 
}

export default LoadPlans
